import { render, staticRenderFns } from "./knowUs.vue?vue&type=template&id=76b3cfb4&"
import script from "./knowUs.vue?vue&type=script&lang=js&"
export * from "./knowUs.vue?vue&type=script&lang=js&"
import style0 from "./knowUs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports